export default __webpack_public_path__ + "static/media/icons8-lock.9625d809.svg";